import React from 'react';
import DraftModuleComp from '../../Components/DraftModule/DraftModuleComp';

const DraftModule = () => {
  return <DraftModuleComp />;
};

export default DraftModule;
